export default {
  currentInsuranceCompany: 'Current health insurance provider',
  postCode: 'Postcode',
  region: 'Region',
  ageGroup: 'Age group',
  compareNow: 'Compare now',
  calculatePremiums: 'Prämien 2020 berechnen',
  selectInsuranceModel: 'Wählen Sie das gewünschte Versicherungsmodell aus:',
  startingFrom: 'schon ab',
  currentFamilyDoctor: 'Aktueller Hausarzt',
  typeToFindDoctors: 'Geben Sie ein, um Ärzte zu suchen',
  selectDesiredDeductible: 'Wählen Sie die gewünschte Franchise (Selbstbehalt) aus:',
  currentInsuranceCompanyPremium: 'Prämie bei Ihrer aktuellen Krankenkasse (Standard)',
  savingPotential: 'Sparpotenzial',
  savingPotentialDescription: 'Sparpotenzial pro Jahr bei einem Wechsel der Krankenkasse mit gleichen Leistungen im KVG',
  year: 'Jahr',
  requestQuote: 'Jetzt Angebot anfordern',
  requestDetailedOffer: 'Jetzt detailliertes Angebot anfordern',
  requestDetailedOfferDescription: 'Sie erhalten eine unverbindliche und kostenlose detaillierte Offerte mit den Prämien 2020',
  whatIsImportant: 'Was ist Ihnen wichtig?',
  male: 'Herr',
  female: 'Frau',
  gender: 'Geschlecht',
  firstName: 'Vorname',
  lastName: 'Nachname',
  street: 'Strasse',
  phone: 'Telefon',
  email: 'Email',
  dateOfBirth: 'Geburtsdatum',
  personsInHousehold: 'Personen im Haushalt',
  send: 'Senden',
  peopleToBeInsured: 'Zu versichernde Person(en)',
  individual: 'Einzelperson',
  family: 'Familie',
  insuranceType: 'Versicherungstyp',
  otherInsurances: 'Weitere Versicherungen',
  continueToOfferSelection: 'Weiter zur Angebotsauswahl',
  supplier: 'Anbieter',
  insuranceName: 'Name der Versicherung',
  totalPremium: 'Prämientotal',
  oneYearBreakdown: 'Aufschlüsselung für 1 Jahr',
  cancellationCosts: 'Annullierungskosten',
  deductible: 'Selbstbehalt',
  moreInsurance: 'Weitere Versicherungen',
  vehicleAssistance: 'Fahrzeug-Assistance',
  legalProtectionAbroad: 'Rechtsschutz im Ausland',
  luggageInsurance: 'Gepackversicherung',
  worldwide: 'Weltweit',
  yes: 'Yes',
  no: 'No',
  select: 'Select',
  back: 'Back',
  number: 'Number',
  pricesCanBeChanged: 'Alle Angaben gemäss Anbieter und ohne Gewähr.',
  insuranceStartDate: 'Versicherungsbeginn',
  insuranceContractDuration: 'Vertragsdauer (in Jahren)',
  yourNationality: 'Ihre Nationalität',
  yourCivilStatus: 'Ihr Zivilstand',
  pleaseSelect: 'Please select',
  thanks: 'Thank you!',
  goBack: 'Go back',
  other: 'Other',
  noCurrentInsurance: 'No insurance',
  dog: 'Hund',
  cat: 'Katze',
  cover: 'Deckung',
  startOfInsurance: 'Versicherungsbeginn',
  pricePerMonth: 'Monatlichesprämie',
  pricePerYear: 'Jahresprämie',
  hereditaryDiseases: 'Erbkrankheiten',
  petName: 'Haustiername',
  race: 'Rasse',
};
